import { parsePhoneNumberFromString } from 'libphonenumber-js/min'
import { shortenBsuid } from '@/lib/utils'

/** "916354809616" → "+91 63548 09616"; "15556162940" → "+1 555 616 2940".
 *  A BSUID (username-only WhatsApp user) is shortened, not formatted. */
export function formatCallNumber(value: string | null | undefined): string {
  if (!value) return ''
  if (/[a-z]/i.test(value)) return shortenBsuid(value)
  const digits = value.replace(/\D/g, '')
  if (!digits) return ''
  return parsePhoneNumberFromString(`+${digits}`)?.formatInternational() ?? `+${digits}`
}

/** 75 → "1:15". */
export function formatCallClock(totalSeconds: number): string {
  const total = Math.max(0, Math.floor(totalSeconds))
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`
}
